import { gql, useQuery } from '@apollo/client';

const GET_AUDIT_METADATA = gql`
  query GetAuditMetadata($applicationId: String) {
    getAuditMetadata(applicationId: $applicationId) {
      auditStage
      pendingDocumentGeneration
      completionPercentage
      isAuditComplete
    }
  }
`;

export interface GetAuditMetadataInput {
  applicationId: string;
}

export interface AuditMetadata {
  auditStage: string;
  pendingDocumentGeneration?: boolean;
  completionPercentage?: number;
  isAuditComplete?: boolean;
}

export interface GetAuditMetadataResult {
  getAuditMetadata: AuditMetadata;
}

export function useGetAuditMetadataQuery(applicationId: string) {
  return useQuery<GetAuditMetadataResult, GetAuditMetadataInput>(GET_AUDIT_METADATA, {
    variables: { applicationId },
    pollInterval: 5000,
  });
}
